<!--最高超速提醒-->
<template>
  <div>
    <div class="page_header">
      <span class="page_title"
        >{{ $t("speedlimit.HspeedWarn")
        }}<span style="margin-left: 6px; color: #ff8c00; font-size: 12px"
          ><kl-icon size="12" icon="icon-icon_prompt2" />{{
            $t("speedlimit.introduce14")
          }}</span
        ></span
      >
      <el-form :inline="true" :size="size" style="flex: 1; text-align: right">
        <el-form-item :label="$t('vehicle.carNo')">
          <el-input
            clearable
            v-model="form.CarNo"
            style="width: 130px"
            :placeholder="$t('vehicle.carNoPls')"
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('vehicle.ManufactureNo')">
          <el-input
            clearable
            v-model="form.ManufactureID"
            style="width: 120px"
            :placeholder="$t('vehicle.ManufactureNoPls')"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">{{
            $t("public.query")
          }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onPatchSetClick" plain>{{
            $t("public.BatchSet")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="page_container">
      <div style="max-height: calc(100vh - 240px); overflow: auto">
        <el-table
          v-loading="loading"
          :size="size"
          :data="list"
          border
          @selection-change="handleSelectionChange"
          style="width: 100%"
        >
          <el-table-column type="selection" align="center" width="45">
          </el-table-column>
          <el-table-column
            prop="CarNo"
            align="center"
            :label="$t('vehicle.carNo')"
          >
          </el-table-column>
          <el-table-column
            prop="DeviceNo"
            align="center"
            :label="$t('vehicle.DeviceNo')"
          >
          </el-table-column>
          <el-table-column
            prop="VelType"
            align="center"
            :label="$t('vechiletype.Type')"
          >
            <!--1 公路车 2 校车-->

            <template slot-scope="scope">
              <span v-if="scope.row.VelType == 1">{{
                $t("vechiletype.Road")
              }}</span>
              <span v-if="scope.row.VelType == 2">{{
                $t("vechiletype.School")
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="MaxSpeed"
            align="center"
            :label="$t('speedlimit.tontyichaosusudu')"
          >
          </el-table-column>
          <el-table-column
            prop="Duration"
            align="center"
            :label="$t('speedlimit.chixunshijian')"
          >
          </el-table-column>
          <el-table-column
            prop="SendTime"
            align="center"
            :label="$t('hightlimit.StorageTime')"
          >
          </el-table-column>
          <el-table-column
            prop="SetLimitSpeed"
            align="center"
            :label="$t('hightlimit.PendingSettingValue')"
          >
            <template slot-scope="scope">
              <span>{{ ParseProtocol(scope.row.ProtocolInfo) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="RespTime"
            align="center"
            :label="$t('hightlimit.SetTime')"
          >
          </el-table-column>
          <el-table-column
            prop="RespResult"
            align="center"
            :label="$t('hightlimit.SetResult')"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.RespResult == 0">{{
                $t("public.Success")
              }}</span>
              <span v-else>
                <span
                  v-if="scope.row.RespResult == '' || !scope.row.RespResult"
                ></span>
                <span v-else> {{ $t("public.Fail") }} </span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="OperatorName"
            align="center"
            :label="$t('public.Operation')"
          >
            <template slot-scope="scope">
              <el-link
                :underline="false"
                @click="onSetClick(scope.row)"
                type="primary"
                >{{ $t("public.Set") }}</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <kl-pagination
        style="margin-bottom: 10px"
        :total="total"
        @current-change="pageChange"
        :current-page.sync="form.PageNo"
      >
      </kl-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="350px"
    >
      <div style="padding: 0 20px">
        <div style="text-align: left">
          <el-form :size="size" label-width="80px">
            <el-form-item v-if="setType == 2" :label="$t('vehicle.carNo')">
              <el-input v-model="carNo"></el-input>
            </el-form-item>
            <limitvalueset :max="200" v-model="speed" :label="$t('speedlimit.chaosusudu')" />
            <limitvalueset v-model="duration" :label="$t('speedlimit.chixunshijian')" :unit="$t('time.second')" />
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" :size="size">{{
          $t("public.cancel")
        }}</el-button>
        <el-button type="primary" @click="saveConfig" :size="size">{{
          $t("public.confirm")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import limitvalueset from "./components/limitvalueset";
export default {
    name:"hightremind",
  components: {
    limitvalueset,
  },
  data() {
    return {
      dialogVisible: false,
      date: [],
      loading: false,
      form: {
        CompanyID: 0,
        OperatorID: 0,
        CarNo: "",
        DeviceNo: "",
        ManufactureID: "",
        VelType: 0,
        PageNo: 1,
        PageSize: 10,
      },
      carNo: "",
      speed: 110,
      duration: 5,
      tableData: [],
      dataList: [],
      total: 0,
      dialogTitle: this.$t('public.Set'),
      multipleSelection: [],
      deleteId: [],
      setType: 0, //1 批量设置 2单车设置
      currentRow: undefined,
    };
  },
  computed: {
    size() {
      return this.$store.getters.size;
    },
    operator() {
      return this.$store.getters.operator;
    },

    list() {
      if (this.dataList != null && this.dataList.length > 0) {
        return this.dataList.slice(
          (this.form.PageNo - 1) * this.form.PageSize,
          this.form.PageNo * this.form.PageSize
        );
      }
    },
  },
  methods: {
    saveConfig() {
      var ids = "";
      if (this.setType == 1) {
        ids = this.deleteId.join(",");
      } else {
        ids = this.currentRow.VehicleID;
      }
      this.$api
        .setOverSpeedRemind({
          OperatorID: this.operator.OperatorId,
          VehicleIDs: ids.toString(),
          MaxSpeed: this.speed,
          Duration: this.duration,
        })
        .then((res) => {
          console.log(res);
          //成功提示
          this.$message({
            type: "success",
            message: this.$t('public.SetSuccess'),
          });
          this.queryList();
          this.dialogVisible = false;
        })
        .catch(() => {
          //失败提示
          this.$message({
            type: "error",
            message: this.$t("public.SetFail"),
          });
        });
      //提交接口保存
    },
    ParseProtocol(protocol) {
      if (protocol == null || protocol == "") {
        return this.$t("public.UnSet");
      } else {
        //0x 02 00 06 04 00 00 00 64 00 07 04 00 00 00 05
        console.log(protocol);
        var value = "";
        var pos = 0;
        var num = parseInt(protocol.substr(pos, 2), 16); //长度
        pos += 2;
        for (var i = 0; i < num; i++) {
          var paraID = protocol.substr(pos, 4); //参数Id
          pos += 4;
          // console.log(paraID);
          var len = parseInt(protocol.substr(pos, 2), 16); //参数长度
          // console.log(len);
          pos += 2;
          if (paraID == "0006") {
            //速度
            if (value != "") value += "；";
            value += this.$t('hightlimit.sudu')+ "：" + parseInt(protocol.substr(pos, len * 2), 16); //参数值
          }
          if (paraID == "0007") {
            //持续时间
            if (value != "") value += "；";
            value += this.$t('speedlimit.chixunshijian')+"：" + parseInt(protocol.substr(pos, len * 2), 16); //参数值
          }
          pos += len * 2;
        }
        return value;
      }
    },
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      console.log(selection);
      this.deleteId = selection.map((item) => item.VehicleID);
      console.log(this.deleteId);
    },
    onSetClick(row) {
      this.currentRow = row;

      this.carNo = row.CarNo;
      this.speed = 110;
      this.duration = 5;

      this.setType = 2; //单车设置
      this.dialogTitle = this.$t('hightlimit.SingleLimitSet');

      this.dialogVisible = true;
    },
    onPatchSetClick() {
      //批量设置
      //批量设置
      if (this.deleteId.length == 0) {
        this.$message({
          type: "warning",
          message: this.$t('public.PlsSelectSetVehicles'),
        });
        return;
      }
      this.setType = 1; //批量设置
      this.carNo = "";
      this.speed = 110;
      this.duration = 5;
      this.dialogTitle = this.$t("public.BatchSet");
      this.dialogVisible = true;
    },
    pageChange(page) {
      this.form.PageNo = page;
      this.queryList();
    },
    init() {
      //初始化查询条件
      //查询日期，最近7天

      var now = this.moment(); //今天
      var prev = this.moment().subtract(7, "days"); //7天前

      this.date = [prev, now];

      this.form.OperatorID = this.operator.OperatorId;
      this.form.CompanyID = this.operator.CompanyId;
    },
    queryList() {
      this.tableData = [];
      this.dataList = [];

      this.loading = true;
      this.$api
        .queryMaxSpeedLawSet(this.form)
        .then((res) => {
          this.loading = false;
          if (res && res.code == 200) {
            //本地分页
            this.dataList = res.data;

            this.total = res.data.length;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onSubmit() {
      //整理查询字段

      this.form.BeginTime = this.moment(this.date[0]).format(
        "YYYY-MM-DD 00:00:00"
      );
      this.form.EndTime = this.moment(this.date[1]).format(
        "YYYY-MM-DD 23:59:59"
      );
      this.form.PageNo = 1;

      this.queryList();
    },
  },
  mounted() {
    this.init();
    this.queryList();
  },
};
</script>
<style scoped lang="scss"></style>
